import React from 'react';
import {ReviewUnit} from "@onegovbugs/onegov-react-components";
import styles from "./ReviewUnitApplication.module.scss";

export const LicenceInformationReviewUnit = ({props, licenceDetails}) => {   
    return (
        <ReviewUnit
            title={"Licence Information"}
            onEdit={() => props.history.push("/import-export/individual-licence-information")}
        >
            <div className={`row ${styles.infoLine}`}>
                <div className={"col-12 col-md-6"}>
                    <div>
                        <em>Licence No</em>
                    </div>
                    <div className={styles.camelCase}>{(licenceDetails ? licenceDetails.currentLicenceNumber : "")}</div>
                </div>
            </div>
            

            <div className={`row ${styles.infoLine}`}>

                <div className={"col-12 col-md-6"}>
                    <div>
                        <em>First Name</em>
                    </div>
                    <div className={styles.camelCase}>{(licenceDetails ? licenceDetails.licenseeGivenName : "")}</div>
                </div>

                <div className={"col-12 col-md-6"}>
                    <div>
                        <em>Last Name</em>
                    </div>
                    <div className={styles.camelCase}>{(licenceDetails ? licenceDetails.licenseeSurname : "")}</div>
                </div>
            </div>      
        </ReviewUnit>
    )
}